import { render, staticRenderFns } from "./dioDetails.vue?vue&type=template&id=424695da&scoped=true&"
import script from "./dioDetails.vue?vue&type=script&lang=js&"
export * from "./dioDetails.vue?vue&type=script&lang=js&"
import style0 from "./dioDetails.vue?vue&type=style&index=0&id=424695da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424695da",
  null
  
)

export default component.exports